const BookShelfLoading = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={86}
    fill="none"
    viewBox="0 0 50 46"
    className={`book-shelf ${props?.className ? props.className : ""}`}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    <path
      fill="#4F46E5"
      className="animate-shelfBounce origin-center ease-in-out"
      d="M2 40a2 2 0 110-4h36a2 2 0 110 4H2z"
    />

    <path
      fill="#818CF8"
      id="nails"
      d="M6 46a2 2 0 01-2-2v-2a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6zM32 46a2 2 0 01-2-2v-2a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2z"
    />

    <g
      className=" animate-[bookBounce_0.8s_ease-in-out_infinite_0ms]"
      id="firstBook"
      fillRule="evenodd"
    >
      <path
        fill="#4338CA"
        d="M4 8a2 2 0 012-2h6a2 2 0 012 2v26a2 2 0 01-2 2H6a2 2 0 01-2-2V8z"
      />
      <path fill="#4F46E5" d="M10 31a1 1 0 11-2 0v-6a1 1 0 112 0v6z" />
    </g>
    <g
      className="animate-[bookBounce_0.8s_ease-in-out_infinite_50ms]"
      id="secondBook"
      fillRule="evenodd"
    >
      <path
        fill="#6366F1"
        d="M14 2a2 2 0 012-2h8a2 2 0 012 2v32a2 2 0 01-2 2h-8a2 2 0 01-2-2V2z"
      />

      <path
        fill="#312E81"
        d="M19.395 17.636a.645.645 0 011.21 0l.372 1.006a.645.645 0 00.382.381l1.005.372a.645.645 0 010 1.21l-1.005.373a.645.645 0 00-.382.381l-.372 1.005a.645.645 0 01-1.21 0l-.372-1.005a.645.645 0 00-.382-.381l-1.005-.372a.645.645 0 010-1.21l1.005-.373a.645.645 0 00.382-.381l.372-1.006z"
      />
    </g>

    <g
      className=" animate-[bookBounce_0.8s_ease-in-out_infinite_100ms]"
      id="thirdBook"
      fillRule="evenodd"
    >
      <path
        fill="#818CF8"
        d="M26 8a2 2 0 012-2h6a2 2 0 012 2v26a2 2 0 01-2 2h-6a2 2 0 01-2-2V8z"
      />
      <path fill="#6366F1" d="M32 31a1 1 0 11-2 0v-6a1 1 0 112 0v6z" />
    </g>
  </svg>
);
export default BookShelfLoading;
